import { render, staticRenderFns } from "./loginCu.vue?vue&type=template&id=d8a6a10a&scoped=true&"
import script from "./loginCu.vue?vue&type=script&lang=js&"
export * from "./loginCu.vue?vue&type=script&lang=js&"
import style0 from "./loginCu.vue?vue&type=style&index=0&id=d8a6a10a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a6a10a",
  null
  
)

export default component.exports